// extracted by mini-css-extract-plugin
module.exports = {"root":"PreviousVersions__root--3cqIq","justified":"PreviousVersions__justified--1sxQZ","input":"PreviousVersions__input--294Ug"};